import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class LanguageDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      multiple,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='language'
          type='language'
          valueField='id'
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    intl: state.intl
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageDropdown);
